// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"96ffb400","80":"4e19d80c","188":"d489f22e","212":"ee53c10b","248":"691037e2","268":"95a14f28","298":"a9e24d56","380":"bbfaa96b","453":"bd86699d","518":"61b98984","630":"e9130847","724":"7e761bde","733":"289e7aae","795":"1889ae5a","880":"e36094c0"}[chunkId] + ".chunk.js";
};